import { useCookie, useRequestHeaders } from "#imports";
import { createIdentificationUniqueId } from "../helpers/createIdentificationUniqueId.js";
const HEADER_NAME = "bm-session-id";
const COOKIE_NAME = "session_id";
const COOKIE_EXPIRATION_SECONDS = 60 * 60 * 24 * 90;
export function useSessionId(settings = { forceRefresh: false }) {
  const headers = useRequestHeaders();
  if (headers[HEADER_NAME]) {
    return headers[HEADER_NAME];
  }
  const cookie = useCookie(COOKIE_NAME, {
    default: () => createIdentificationUniqueId(),
    maxAge: COOKIE_EXPIRATION_SECONDS,
    secure: true
  });
  if (settings.forceRefresh) {
    const backup = cookie.value;
    cookie.value = "";
    cookie.value = backup;
  }
  return cookie.value;
}
